import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}
export function ProgressBar({
  currentStep,
  totalSteps
}: ProgressBarProps) {
  const progress = currentStep / totalSteps * 100;
  return <div className="w-full mb-12" data-id="element-23">
      <div className="flex justify-between items-end mb-3" data-id="element-24">
        <span className="text-sm font-semibold text-slate-500 uppercase tracking-wider" data-id="element-25">
          Question {currentStep} of {totalSteps}
        </span>
        <span className="text-sm font-medium text-minerva" data-id="element-26">
          {Math.round(progress)}%
        </span>
      </div>
      <div className="h-1.5 w-full bg-slate-200 rounded-full overflow-hidden" data-id="element-27">
        <motion.div className="h-full bg-minerva rounded-full" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-28" />
      </div>
    </div>;
}